var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhotoCameraBack = function SvgPhotoCameraBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.68 2.18c.898 0 1.64.742 1.64 1.64v10c0 .938-.742 1.68-1.64 1.68H2.32c-.898 0-1.64-.742-1.64-1.68v-10c0-.898.742-1.64 1.64-1.64h2.657l1.015-1.133A1.69 1.69 0 0 1 7.242.5h3.516c.469 0 .937.195 1.25.547l1.015 1.133zm-2.5 10c.312 0 .547-.39.312-.664L11.227 8.43a.495.495 0 0 0-.704 0l-2.148 2.89-1.523-2.03a.44.44 0 0 0-.704 0l-1.64 2.226c-.235.273 0 .664.312.664z"
  })));
};
export default SvgPhotoCameraBack;